import React from 'react';
import renderHTML from 'react-render-html';

const FactSource = ({ title, fact, source, imgeSrc, alt }) => {
	return (
		<section className="row fact">
			<div className="col sm-6 content">
				<h2 className="title">{ renderHTML(title) }</h2>
				<p className="descr">{ renderHTML(fact) }</p>
				{ source !== undefined ? <p className="source">{ renderHTML(source) }</p> : null }
			</div>
			<div className="col sm-6 image">
				<img src={ imgeSrc } alt={ alt } />
			</div>
		</section>
	);
};

export default FactSource;


// WEBPACK FOOTER //
// ./src/pages/category/common/FactSource.js